<template>
    <span class="dddpre" v-html="dotdotdot"></span>
</template>

<script>
export default {
    name: "DotDotDot",
    data() {
        return {
            time: 0,
        };
    },
    created() {
        setInterval(this.timer, 600);
    },
    computed: {
        dotdotdot() {
            const d = "...";
            return (d.substring(0, this.time) + String.fromCharCode(160, 160, 160)).substr(0, 3);
        },
    },
    methods: {
        timer() {
            this.time > 2 ? (this.time = 0) : this.time++;
        },
    },
};
</script>

<style scoped>
.dddpre {
    white-space: pre;
    font-family: pre;
}
</style>
